module.exports = __webpack_public_path__ + "static/media/u35_premium_contract1.5d44af49.webp";